import React from 'react';
import {
  Page, Section, SectionTitleUnderlined, ExperienceList,
  LineList, SkillsInline, ContactRow
} from './_shared';

/**
 * "Academic" template (key: bordered-academic).
 *
 * Traditional academic CV layout. Times New Roman, full-justified body text,
 * generous line spacing, single black rule under the name. Use for PhD,
 * research, faculty, post-doc, and grant applications. Avoid for industry tech.
 */

const ACCENT = '#000000';

const BorderedAcademic = ({ data }) => {
  const fontFamily = "'Times New Roman', 'Cambria', 'Liberation Serif', serif";
  return (
    <Page accent={ACCENT} fontFamily={fontFamily} padding="1in" style={{ lineHeight: 1.55 }}>
      <header style={{ textAlign: 'center', marginBottom: '1rem' }}>
        <h1 style={{
          fontSize: '20pt',
          fontWeight: 700,
          margin: 0,
          letterSpacing: '0.02em',
          textTransform: 'uppercase'
        }}>
          {data.fullName}
        </h1>
        {data.jobTitle && (
          <div style={{
            fontSize: '11pt',
            marginTop: '4px',
            fontStyle: 'italic'
          }}>
            {data.jobTitle}
          </div>
        )}
        <ContactRow data={data} separator=" | " style={{ marginTop: '8px' }} />
        <div style={{ height: '1px', background: ACCENT, marginTop: '0.7rem' }} />
      </header>

      {data.summary && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} uppercase={false} letterSpacing="0.04em">Research Statement</SectionTitleUnderlined>
          <p style={{ margin: 0, textAlign: 'justify' }}>{data.summary}</p>
        </Section>
      )}

      {data.education && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} uppercase={false} letterSpacing="0.04em">Education</SectionTitleUnderlined>
          <LineList text={data.education} />
        </Section>
      )}

      {data.experience && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} uppercase={false} letterSpacing="0.04em">Academic & Professional Experience</SectionTitleUnderlined>
          <ExperienceList text={data.experience} accent={ACCENT} />
        </Section>
      )}

      {data.certifications && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} uppercase={false} letterSpacing="0.04em">Honors & Certifications</SectionTitleUnderlined>
          <LineList text={data.certifications} />
        </Section>
      )}

      {data.skills && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} uppercase={false} letterSpacing="0.04em">Research Skills</SectionTitleUnderlined>
          <SkillsInline skills={data.skills} separator="; " />
        </Section>
      )}

      {data.languages && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT} uppercase={false} letterSpacing="0.04em">Languages</SectionTitleUnderlined>
          <LineList text={data.languages} />
        </Section>
      )}
    </Page>
  );
};

export default BorderedAcademic;
